import {
  LabelHintAndError
} from "./chunk-YWO4J7SP.mjs";

// src/input/src/input.tsx
import { cx } from "class-variance-authority";
import { forwardRef, useId } from "react";
import { useDescribedBy } from "@thisisbud/gds-shared-utilities";
import { jsx, jsxs } from "react/jsx-runtime";
var Input = forwardRef(
  ({
    type = "text",
    name,
    label,
    hint = "",
    prefixText = "",
    placeholder,
    suffixText = "",
    errorMessage = "",
    disabled = false,
    hideLabel = false,
    startIcon = false,
    endIcon = false,
    value,
    onChange
  }, ref) => {
    const labelIdInternal = useId();
    const hintIdInternal = useId();
    const errorIdInternal = useId();
    const hasHint = Boolean(hint);
    const hasError = Boolean(errorMessage);
    const hintId = hasHint ? hintIdInternal : void 0;
    const errorId = hasError ? errorIdInternal : void 0;
    const describedBy = useDescribedBy(hintId, errorId);
    const inputBoxClasses = cx(
      "flex w-full items-center rounded bg-surface-light px-3 py-2 text-surface-dark ring-1 focus-within:ring-2 focus-within:ring-surface-dark",
      {
        "!ring-interactive-disabled": disabled,
        "ring-state-negative-graphics !ring-2": hasError,
        "ring-surface-border": !disabled && !hasError
      }
    );
    const inputClasses = cx(
      "w-full grow appearance-none truncate focus:outline-none disabled:bg-transparent disabled:text-surface-dark",
      {
        "text-interactive-disabled": disabled,
        "text-right": suffixText,
        "text-surface-dark": !disabled
      }
    );
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(
        LabelHintAndError,
        {
          disabled,
          errorId,
          errorMessage,
          hideLabel,
          hint,
          hintId,
          label,
          labelId: labelIdInternal
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: inputBoxClasses, children: [
        Boolean(startIcon) || Boolean(prefixText) ? /* @__PURE__ */ jsx(
          "span",
          {
            className: cx("", {
              "pr-1": prefixText,
              "pr-2": startIcon,
              "text-interactive-disabled": disabled,
              "text-surface-body": !disabled && prefixText,
              "text-surface-dark": !disabled && startIcon
            }),
            children: startIcon || prefixText
          }
        ) : null,
        /* @__PURE__ */ jsx(
          "input",
          {
            "aria-describedby": describedBy,
            "aria-invalid": hasError,
            className: inputClasses,
            disabled,
            id: labelIdInternal,
            inputMode: type === "number" ? "numeric" : void 0,
            name,
            pattern: type === "number" ? "[0-9]*" : void 0,
            placeholder,
            ref,
            type: type === "number" ? "text" : type,
            value,
            onChange
          }
        ),
        Boolean(endIcon) || Boolean(suffixText) ? /* @__PURE__ */ jsx(
          "span",
          {
            className: cx("pl-2", {
              "text-interactive-disabled": disabled,
              "text-surface-body": !disabled && suffixText,
              "text-surface-dark": !disabled && endIcon
            }),
            children: endIcon || suffixText
          }
        ) : null
      ] })
    ] });
  }
);

export {
  Input
};
